import { Component, forwardRef, ChangeDetectionStrategy } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { RegExPattern } from '../../../../core/models/regexp-pattern/regex-pattern';
import {
    ControlValueAccessor,
    FormsModule,
    ReactiveFormsModule,
    NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { ResourcesService } from '../../../../core/services/resources/resources.service';
import { MatSelectModule } from '@angular/material/select';
import {
    UserRole,
    UserRoleLabelMapping,
} from '../../../../core/enums/users/role';

@Component({
    selector: 'app-role-input',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
    ],
    templateUrl: './user-role-input.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => UserRoleInputComponent),
            multi: true,
        },
    ],
})
export class UserRoleInputComponent implements ControlValueAccessor {
    role?: string = '';
    userRoles: UserRole[] = Object.values(UserRole).filter(
        (role) => typeof role === 'number',
    ) as UserRole[];

    readonly UserRoleLabelMapping = UserRoleLabelMapping;

    regExPattern = RegExPattern;

    private onChange: (value: string) => void = () => {};
    private onTouched: () => void = () => {};

    constructor(private readonly resourcesService: ResourcesService) {}

    writeValue(value: string): void {
        this.role = value;
    }

    registerOnChange(fn: (value: string) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    onInputChange(value: string): void {
        this.onChange(value);
        this.onTouched();
    }
}
